import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InvoiceStatementService from "services/InvoiceStatementService";

const DEBOUNCE_MS = 400;
const MIN_KEYWORD_LENGTH = 2;

// Response có thể bọc trong data hoặc items tùy endpoint, gỡ dần cho chắc
const readOptions = response =>
  response?.data?.items || response?.items || response?.data || [];

// Gợi ý người mua cho ô tìm kiếm. Lỗi thì im lặng (chỉ mất gợi ý),
// người dùng vẫn gõ tự do được nên không toast.
export const useBuyerSearch = keyword => {
  const [debounced, setDebounced] = useState("");

  // Chỉ tìm trong phạm vi chi nhánh/đơn vị đang chọn trên header
  const Dashboard = useSelector(state => state.Dashboard);
  const bucode = Dashboard?.finalBuInfo?.code;

  useEffect(() => {
    const timer = setTimeout(
      () => setDebounced((keyword || "").trim()),
      DEBOUNCE_MS
    );
    return () => clearTimeout(timer);
  }, [keyword]);

  const query = useQuery({
    queryKey: ["invoice-statement", "buyer", bucode, debounced],
    queryFn: () =>
      InvoiceStatementService.searchBuyers({ bucode, keyword: debounced }),
    enabled: Boolean(bucode) && debounced.length >= MIN_KEYWORD_LENGTH,
    retry: 0,
    staleTime: 5 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    options: Array.isArray(readOptions(query.data))
      ? readOptions(query.data)
      : [],
    isLoading: query.isFetching,
  };
};
